import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/admin/pickups")({
  head: () =>
    buildHead({
      title: "Doorstep Pickups | LohaLink Admin",
      description: "Internal queue for doorstep scrap pickup requests.",
      canonical: "/admin/pickups",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/admin/Pickups")),
});
